import CollectionApi from 'client/api/v2/CollectionApi';

class ConfigurationGroupApi extends CollectionApi {
  constructor() {
    super('/api/v2/policygroups', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
        value: '',
      }],
    });
  }

  fetchPolicyGroupsBySearchTerm(searchTerm) {
    return this.axios.get(`${this.baseUrl}?skip=0&limit=50&sort=name&filter=type:eq:policy_group,name:search:${searchTerm}`);
  }

  // temp API call in order to disable the "save as template" button in the
  // Policy Group Aside if no policies are bound
  fetchBoundPolicies(id, limit) {
    return this.axios.get(`${this.baseUrl}/${id}/membership?details=v1&skip=0&limit=${limit}`);
  }
}

export default new ConfigurationGroupApi();
